import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

export const useTicketActions = () => {
  const queryClient = useQueryClient();

  const updateTicketStatus = useMutation({
    mutationFn: async ({ 
      ticketId, 
      newStatus, 
      adminId 
    }: { 
      ticketId: string; 
      newStatus: string; 
      adminId?: string;
    }) => {
      const { data, error } = await supabase.rpc('update_ticket_status', {
        p_ticket_id: ticketId,
        p_new_status: newStatus,
        p_admin_id: adminId,
      });
      
      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-tickets'] });
      queryClient.invalidateQueries({ queryKey: ['admin-pending-activities'] });
      toast.success('Status do ticket atualizado!');
    },
    onError: (error) => {
      console.error('Erro ao atualizar ticket:', error);
      toast.error('Erro ao atualizar ticket. Tente novamente.');
    },
  });

  return {
    updateTicketStatus,
  };
};
